import { withHandlers } from 'recompose';
import * as R from 'ramda';

import { Checkbox as CKBXC } from './Checkbox';

const enhance = withHandlers({
  onChange: ({ onChange }) => e => {
    const value = R.pathOr(false, ['target', 'checked'], e);

    onChange && onChange(value);
  },
});

export const Checkbox = enhance(CKBXC);
